import { Td, TableCellProps } from "@chakra-ui/react";
import { useTenant } from "modules/tenant/providers/tenant-provider";

type TdDeveloperModeProps = TableCellProps & {
  children: React.ReactNode;
};

export function TdDeveloperMode({ children, ...props }: TdDeveloperModeProps) {
  const { developerMode } = useTenant();

  if (!developerMode) return null;

  return <Td {...props}>{children}</Td>;
}
